
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/layout/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-green-50">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">The PEO App, Inc. — Terms & Conditions</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">Effective Date: April 28, 2025</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
              <p>Welcome to The PEO App, Inc. ("Company," "we," "our," "us"). These Terms & Conditions ("Terms") govern your use of our website, platform, and services ("Services"). By accessing or using our Services, you agree to these Terms.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Services Provided</h2>
              <p>The PEO App, Inc. provides a platform for businesses to submit company information, compare PEO options, and facilitate connections with PEO providers. We do not provide legal, financial, or employment services ourselves and are not responsible for the performance of any third-party PEO.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. User Accounts</h2>
              <p>You may need to create an account to access certain features. You are responsible for maintaining the confidentiality of your credentials and for all activity conducted under your account.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Information Submission and Use</h2>
              <p>By submitting your information, you agree:</p>
              <ul className="list-disc pl-6 mb-4">
                <li>To provide accurate, current, and complete information.</li>
                <li>That we may share your submitted information with select PEO providers for the purpose of generating quotes and service proposals.</li>
                <li>That you have authorization to provide any information related to your business or employees.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Optional Services</h2>
              <p>We may offer optional paid services that enhance your experience but are not required to access basic quoting functionality. Selection or rejection of optional services will not impact your ability to receive PEO matches.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Broker Access and Information Sharing</h2>
              <p>We may share your information with a broker if you voluntarily use a broker's invitation link or enter a private broker access code. Otherwise, your information will not be shared with brokers.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Broker Agreement Terms</h2>
              <p>By using The PEO App, brokers agree to abide by The PEO App's standard partnership terms. Brokers acknowledge that The PEO App negotiates its own separate agreements with PEO providers and their assigned representatives. Brokers may not alter, negotiate, or override The PEO App's partnerships without prior written approval. No promises of compensation or commissions are made to brokers unless explicitly agreed to in a separate, signed agreement with The PEO App, Inc.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Data Access Controls</h2>
              <p>Brokers and PEO users are only authorized to access customer information expressly assigned to them via customer consent or administrative permissions. Unauthorized access, sharing, or misuse of information is strictly prohibited.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Data Security</h2>
              <p className="mb-4">We use HIPAA-compliant and SOC 2-audited infrastructure to secure your data. However, no system is 100% secure, and you acknowledge that you provide information at your own risk.</p>
              <p>For comprehensive details about our security infrastructure, compliance certifications, and data protection measures, please visit our <a href="https://trust.delve.co/the-peo-app" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Trust Center</a>.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Disclaimers</h2>
              <p>We do not guarantee specific outcomes, acceptance by any PEO, or cost savings. Decisions made based on PEO quotes are solely between you and the selected provider.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Limitation of Liability</h2>
              <p>To the maximum extent allowed by law, The PEO App, Inc. shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or for any loss of profits or revenues.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Changes</h2>
              <p>We may update these Terms from time to time. Updates will be posted, and continued use constitutes acceptance of any changes.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Governing Law</h2>
              <p>These Terms are governed by the laws of the State of Delaware without regard to its conflict of law provisions.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Contact</h2>
              <p>For any questions, please contact us at <a href="mailto:info@thepeoapp.com" className="text-primary hover:underline">info@thepeoapp.com</a>.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
